"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalWrite = void 0;
const retry_1 = require("./sync/retry");
/**
 * Similar to transactionalReadWrite and transactionalReadWriteAsync but only allows writes.
 */
function transactionalWrite(retries = 5) {
    return function (fn) {
        return function (dbOrTx, ...args) {
            if ("set" in dbOrTx)
                return fn(dbOrTx, ...args);
            return (0, retry_1.retry)(retries, () => {
                const tx = dbOrTx.transact();
                const result = fn(tx, ...args);
                tx.commit();
                return result;
            });
        };
    };
}
exports.transactionalWrite = transactionalWrite;
//# sourceMappingURL=../../src/database/transactionalWrite.js.map